import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selectors as userSelectors } from 'dux/user';
import { actionCreators, selectors as instanceSelectors } from '../../dux/instances';
import UserList from './UserList';

const propTypes = {
  instanceId: PropTypes.string.isRequired,
  instanceService: PropTypes.string.isRequired,
  getInstanceCertificates: PropTypes.func.isRequired,
  getInstanceClientCertificates: PropTypes.func.isRequired,
  getCerts: PropTypes.func.isRequired,
  getClientCerts: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  userRoles: userSelectors.getIdentityState(state).roles,
  getCerts: instanceSelectors.getCerts(state),
  getClientCerts: instanceSelectors.getClientCerts(state),
});

const mapDispatchToProps = {
  getInstanceCertificates: actionCreators.getInstanceCertificates,
  getInstanceClientCertificates: actionCreators.getInstanceClientCertificates,
  deleteInstanceUser: actionCreators.deleteInstanceUser,
};

class UserListContainer extends React.Component {
  componentDidMount() {
    const {
      instanceId,
      instanceService,
      getInstanceCertificates,
      getInstanceClientCertificates,
    } = this.props;

    if (
      instanceService.toLowerCase() === 'cockroachdb' ||
      instanceService.toLowerCase() === 'mongodb'
    ) {
      getInstanceCertificates(instanceService, instanceId);
      getInstanceClientCertificates(instanceService, instanceId);
    }
  }

  render() {
    const { instanceId, getCerts, getClientCerts } = this.props;
    const certs = getCerts(instanceId);
    const clientCerts = getClientCerts(instanceId);
    return <UserList certs={certs} clientCerts={clientCerts} {...this.props} />;
  }
}

UserListContainer.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(UserListContainer);
